var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fb8caf;}.cls-2{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.84,0l22.84,22.84-5.16,5.16L22.84,10.32,5.16,28,0,22.84,22.84,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.35,.64h3.34l10.32,26.92h-3.86l-2.97-8.09h-10.06l-2.82,8.09h-3.75L70.35,.64Zm5.76,15.86l-4.08-11.14-3.86,11.14h7.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.47,.64h9.43c5.61,0,8.95,2.67,8.95,7.2s-2.75,7.28-7.5,7.76l7.91,11.96h-4.2l-7.8-11.88h-3.27v11.88h-3.53V.64Zm9.43,12.07c3.49,0,5.53-1.82,5.53-4.86,0-2.67-2.04-4.23-5.53-4.23h-5.9V12.71h5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.53,.64h3.53V27.56h-3.53V.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.98,3.61h-8.35V.64h20.2V3.61h-8.32V27.56h-3.53V3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.44,.64h4.98l8.24,20.91L158.68,.64h5.38V27.56h-3.53V5.21l-8.65,22.35h-2.49l-8.47-21.8V27.56h-3.49V.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.34,.64h3.34l10.32,26.92h-3.86l-2.97-8.09h-10.06l-2.82,8.09h-3.75L176.34,.64Zm5.75,15.86l-4.08-11.14-3.86,11.14h7.95Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.33e6141fad8051225ec17f2d503c8d60.svg";
export { ForwardRef as ReactComponent };